<template>
  <div>
    <template v-if="imageUrl">
      <img
        :src="imageUrl"
        alt="Vista previa"
        class="img-fluid img-thumbnail w-100 mb-3"
      />
    </template>
    <input
      type="file"
      @change="onGeneratePreview"
      ref="inputFile"
      class="hidden"
    />
    <small class="form-control-feedback">{{ contentFeedback }}</small>
    <el-button type="primary" class="btn-block"
      @click="onShowFilePicker"
      :loading="loading"
      :disabled="loading"
    >
      {{ labelBtn }}
    </el-button>
  </div>
</template>

<script>
export default {
  props: {
    config: {
      type: Object,
      required: true,
    },
    is_icon: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      imageUrl: "",
      loading: false,
    };
  },
  mounted() {
    this.imageUrl = this.is_icon ?
                      this.config.icon :
                      this.config.image
  },
  computed: {
    labelBtn : function() {
      return this.is_icon ? 'Cambiar imagen de icono de la empresa' : 'Cambiar imagen de fondo'
    },

    contentFeedback : function() {
      return this.is_icon ?
        'Se recomienda una imagen de 700 x 300 con fondo transparente en formato PNG' :
        'Se recomienda una imagen de 747 x 547px con fondo transparente en formato PNG o SVG'
    }
  },
  methods: {
    onShowFilePicker() {
      this.$refs.inputFile.click();
    },
    onGeneratePreview(event) {
      const files = event.target.files;
      if (files.length > 0) {
        const fileReader = new FileReader();
        fileReader.addEventListener("load", () => {
          this.imageUrl = fileReader.result;
        });
        fileReader.readAsDataURL(files[0]);
        const image = files[0];
        const payload = new FormData();
        let url = "/login-page/upload-bg-image"
        if (this.is_icon) {
          payload.append("icon", image);
          url = "/login-page/upload-icon-image"
        } else {
          payload.append("image", image);
        }
        this.loading = true;
        this.$http
          .post(url, payload)
          .then((response) => {
            this.$message({
              message: response.data.message,
              type: "success",
            });
          })
          .catch(error => {
              if (error.response.status === 500) {
                  this.$message.error(error.response.data.message)
              }
          })
          .finally(() => this.loading = false);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/views/tenant/login/UploadBgImage.vue